/**
 * Messages d'encouragement de l'espace élève — pools français par contexte,
 * tirés aléatoirement avec anti-répétition immédiate (jamais deux fois de
 * suite le même message d'un pool). Aucun état React : à consommer via
 * useMemo keyé sur la question/l'ouverture pour un message stable par écran.
 */

const POOLS = {
    bonne: [
        'Bravo !',
        'Excellent !',
        'Bien joué !',
        'Tano est fier de toi !',
        'En plein dans le mille !',
        'Trop fort !',
        'Magnifique !',
        'Tu gères !',
        'Le tuit-tuit chante pour toi !',
        'Le volcan gronde de joie !',
    ],
    mauvaise: [
        'Pas grave, on apprend !',
        'Presque ! La prochaine est pour toi.',
        'Tano croit en toi !',
        'Chaque erreur te rend plus fort.',
        'Regarde bien la correction, ça va rentrer !',
        'On se relève et on continue !',
        'Même un tuit-tuit rate un envol de temps en temps !',
    ],
    miParcours: [
        'Déjà la moitié ! 💪',
        'Tu tiens le bon rythme !',
        'La moitié du chemin est faite, continue !',
        'Tano vole à mi-parcours avec toi !',
        'Mi-pente ! Le sommet approche !',
    ],
    derniereLigne: [
        'Dernière question, donne tout !',
        'Encore une et c\'est gagné !',
        'La ligne d\'arrivée est là !',
        'Le sommet est juste là, un dernier effort !',
    ],
    fin: [
        'Quiz terminé !',
        'Mission accomplie !',
        'Et voilà le travail !',
        'Tu l\'as fait !',
        'Beau vol, champion !',
        'L\'île se réveille grâce à toi !',
    ],
    tips: [
        'Prends ton temps pour bien lire chaque question.',
        'Relis l\'énoncé avant de valider.',
        'Élimine d\'abord les réponses impossibles.',
        'Respire un bon coup, tu as le temps.',
        'Une question à la fois, tu avances bien.',
    ],
};

const STREAK_POOLS = {
    3: ['3 d\'affilée ! 🔥', 'Série de 3 ! Ça chauffe !', 'Trois de suite, quel talent !'],
    5: ['5 d\'affilée ! Incroyable ! 🔥🔥', 'Série de 5 ! Tano n\'en revient pas !', 'Cinq de suite, tu es en feu !'],
    10: ['10 D\'AFFILÉE ! LÉGENDAIRE ! 🔥🔥🔥', 'Série de 10 ! Tano fait des loopings !'],
};

// Anti-répétition immédiate : dernier index servi, par pool.
const derniers = {};

const tirer = (liste, cle) => {
    if (!Array.isArray(liste) || liste.length === 0) return '';
    if (liste.length === 1) return liste[0];
    let idx = Math.floor(Math.random() * liste.length);
    if (idx === derniers[cle]) idx = (idx + 1) % liste.length;
    derniers[cle] = idx;
    return liste[idx];
};

/** Message aléatoire d'un pool ('bonne', 'mauvaise', 'miParcours', 'derniereLigne', 'fin', 'tips'). */
export const pickMessage = (poolId) => tirer(POOLS[poolId] || [], poolId);

/** Message de palier de série (3, 5 ou 10 — repli sur le palier inférieur connu). */
export const pickStreakMessage = (palier) => {
    const cle = STREAK_POOLS[palier] ? palier : palier >= 10 ? 10 : palier >= 5 ? 5 : 3;
    return tirer(STREAK_POOLS[cle], `streak${cle}`);
};

/** Tip contextuel du bas de quiz : mi-parcours et dernière ligne droite priment. */
export const pickTip = (globalCurrent, globalTotal) => {
    if (globalTotal >= 4 && globalCurrent === Math.ceil(globalTotal / 2)) return pickMessage('miParcours');
    if (globalTotal >= 2 && globalCurrent === globalTotal) return pickMessage('derniereLigne');
    return POOLS.tips[(globalCurrent - 1 + POOLS.tips.length) % POOLS.tips.length];
};
